<template>
  <div class="viewport align-items-center justify-content-center viewport-with-top-nav viewport-compact">
    <spinner v-if="submittingApplication"></spinner>
    <template v-else>
      <TopNav></TopNav>
      <LoanAgreement @submit-loan-application="onSubmitClicked"
                     :application="application"
                     :draft="draft"
                     :isNewCustomer="false"
                     :includeCreditRegistryConsent="includeCreditRegistryConsent"
                     :showPepConsentLink="showPepConsentLink"
                     :showMarketingConsentLink="showMarketingConsentLink"
                     :showApr="isShownApr"
                     :showEir="isShownEir"
                     :hideTermsList="hideTermsList"
      />
    </template>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import LoanApplicationMixin from '@shared/mixins/LoanApplicationMixin'
import LoanAgreement from '@shared/components/LoanAgreement'

export default {
    name: 'WithoutOfferAgreementPage',
    mixins: [LoanApplicationMixin],
    props: ['includeCreditRegistryConsent', 'showPepConsentLink', 'showMarketingConsentLink', 'showApr', 'showEir', 'hideTermsList'],
    components: { TopNav, LoanAgreement },
    data () {
      return {
        submittingApplication: false,
        state: store.state,
        draft: store.getDraft(),
        application: store.getApplication()
      }
    },
    computed: {
      isShownApr() {
        return this.showApr === undefined ? true : this.showApr
      },
      isShownEir() {
        return this.showEir === undefined ? false : this.showEir
      }
    },
    methods: {
      onSubmitClicked() {
        this.submittingApplication = true
        store.setApplication(this.application)
        this.$router.push({ name: 'without-offer-login-otp' })
      }
    }
  }
</script>
